import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from '../../../../services/app.service';

@Component({
  selector: 'app-manual-seller',
  templateUrl: './manual-seller.page.html',
  styleUrls: ['./manual-seller.page.scss'],
})
export class ManualSellerPage implements OnInit {

  @Input() public activeseller: any;

  public appPages = [
    {
      title: "Search",
      url: "/seller-data",
      icon: "mail",
      action: 1,
    },
    {
      title: "Data Detail",
      url: "/seller-detail",
      icon: "paper-plane",
      action: 2,
    }
  ];

  constructor(public router: Router, public appService: AppService) {}

  ngOnInit() {
    // this.appService.active.subscribe((value) => {
    //   console.log("value...", value);
    //   this.activecustomer = value;
    // });
  }

  ionViewDidEnter(){
    this.appService.active.subscribe((value) => {
      console.log("value...", value);
      this.activeseller = value;
    });
  }

  clickMenu(a) {
    // this.appService.setActive(a);
    // this.router.navigate([a.url]);

    if (a.action === 1) {
      this.appService.setActive(a);
      this.router.navigate([a.url]);
    }
    // if (a.action === 2) {
    //   this.appService.setActive(a);
    //   this.router.navigate([a.url]);
    // }
  }

}
